import React from 'react';
import { ReactComponent as Check} from "../../../images/svg/check.svg";
import { ReactComponent as Edit} from "../../../images/svg/pencil.svg";

const CBStep = ({index,currentSelection, primary="Primary Text",secondary="", onClick=(e=>console.log('a')) }) => {
    return index >= currentSelection  ? <div className={`font-sarabun ${index == currentSelection ?  'bg-neutral_1 border-neutral_1' : 'bg-white border-neutral_0' } text-neutral_4 border-2 rounded-sm  p-4 flex space-x-3 cursor-pointer`}>
    <div><div className={`rounded-full ${index == currentSelection ?  'bg-burnt shadow-circle border-burnt text-white border-2' : 'text-neutral_4 bg-neutral_1 border-0'  }  h-6 w-6    flex items-center justify-center`}>{index+1}</div></div>
    <div className="grid grid-cols-1">
    <div className="font-sarabun text-neutral_4">{primary}</div>
    <div className="font-sarabun text-neutral_3">{secondary}</div>
    </div>
      </div> 
      : 
 
     
    <div onClick={e=>onClick(e)} className="font-sarabun text-neutral_4 border-2 border-neutral_0 rounded-sm hover:border-neutral_2  p-4 flex space-x-3 cursor-pointer">
   <div className="m-2"><Check></Check></div>
   <div className="grid grid-cols-1">
   <div className="font-sarabun text-neutral_4">{primary}</div>
   <div className="font-sarabun text-neutral_3">{secondary}</div>
   </div>
   <div className="flex-grow"></div>
   <div className="justify-self-end m-1">
     <Edit ></Edit></div>
     </div>
     
 }

 export { CBStep };
